import { render, staticRenderFns } from "./betsummary.vue?vue&type=template&id=9dd8e7d0"
import script from "./betsummary.vue?vue&type=script&lang=js"
export * from "./betsummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports